import React from 'react'
import Marquee from "react-fast-marquee";

const Logos = () => {
  return (
    <>
      <Marquee>
        <section
          data-w-id="32214d7b-22a1-efc2-5da1-7a8b71b15c67"
          style={{
            opacity: 1,
            transform:
              "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
            transformStyle: "preserve-3d",
          }}
          className="section-with-120px-margin"
        >
          <div
            data-w-id="32214d7b-22a1-efc2-5da1-7a8b71b15c68"
            style={{
              transform:
                "translate3d(-16.777vw, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
              transformStyle: "preserve-3d",
              willChange: "transform",
            }}
            className="logo-container"
          >
            <img
              loading="lazy"
              src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8fb178fa9afe7f5d5e_Group-1.avif"
              alt=""
              className="logo-image"
            />
            <img
              loading="lazy"
              src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8f90bc3625ce9e838b_Group-2.avif"
              alt=""
              className="logo-image"
            />
            <img
              loading="lazy"
              src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8fbe961554747d86cc_Group.avif"
              alt=""
              className="logo-image"
            />
            <img
              loading="lazy"
              src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8ef20d7dc9b85b792e_OBJECTS.avif"
              alt=""
              className="logo-image"
            />
            <img
              loading="lazy"
              src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8ee838030a66277553_Group-3.avif"
              alt=""
              className="logo-image"
            />
            <img
              loading="lazy"
              src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8fb178fa9afe7f5d5e_Group-1.avif"
              alt=""
              className="logo-image"
            />
            <img
              loading="lazy"
              src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8f90bc3625ce9e838b_Group-2.avif"
              alt=""
              className="logo-image"
            />
            <img
              loading="lazy"
              src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8fbe961554747d86cc_Group.avif"
              alt=""
              className="logo-image"
            />
            <img
              loading="lazy"
              src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8ef20d7dc9b85b792e_OBJECTS.avif"
              alt=""
              className="logo-image"
            />
            <img
              loading="lazy"
              src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b5df8ee838030a66277553_Group-3.avif"
              alt=""
              className="logo-image"
            />
          </div>
        </section>
      </Marquee>
    </>
  );
}

export default Logos
